import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
export const useDownloadBlob = () => {
  const $ = _c(1);
  const downloadBlob = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      downloadBlob
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0 as const;
};
function _temp(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}